import store, { actions } from "../../redux";
import { ReactionsProps } from "../../redux/slices/reactions/Reactions";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;
const addAReactionToAPost = (
  payload: ReactionsProps.AddReactionToAPostPayload
) => {
  const { post_id, reaction_type } = payload;
  const { name, primary_reaction } =
    store.getState().reactions.reactions[reaction_type];
  const user_reacted = {
    reacted: true,
    reaction_id: "",
    reaction_type_id: reaction_type,
    reaction_name: name,
    reaction_primary_reaction: primary_reaction,
  };
  dispatch(
    actions.newsfeed.immediateUpdateForReactions_ADD({
      post_id,
      reaction_type,
      user_reacted,
    })
  );

  dispatch(actions.reactions.setAddReactionToAPost_API_STATUS("progress"));
  API_INSTANCES.POST_REACTIONS.addAReactionToAPost(payload)
    .then((response) => {
      const data = response.data as ReactionsProps.AddReactionToAPostResponse;
      dispatch(
        actions.newsfeed.updateReactionCountForAPost({
          ...data,
          post_id: payload.post_id,
        })
      );
      dispatch(actions.reactions.setAddReactionToAPost_API_STATUS("success"));
    })
    .catch((error) => {
      handleError(error, "addReactionToAPost");
      dispatch(actions.reactions.setAddReactionToAPost_API_STATUS("error"));
    });
};

const getTotalReactionsForAPost = (
  payload: ReactionsProps.GetTotalReactionsForAPostPayload
) => {
  dispatch(
    actions.reactions.setGetTotalReactionsForAPost_API_STATUS("progress")
  );
  API_INSTANCES.POST_REACTIONS.getTotalReactionsForAPost(payload)
    .then((response) => {
      const data = response.data as ReactionsProps.AddReactionToAPostResponse;
      dispatch(
        actions.newsfeed.updateReactionCountForAPost({
          ...data,
          post_id: payload.post_id,
        })
      );
      dispatch(
        actions.reactions.setGetTotalReactionsForAPost_API_STATUS("success")
      );
    })
    .catch((error) => {
      handleError(error, "getTotalReactionsForAPost");
      dispatch(
        actions.reactions.setGetTotalReactionsForAPost_API_STATUS("error")
      );
    });
};

const updateAReactionToAPost = (
  payload: ReactionsProps.UpdateAReactionToAPostPayload
) => {
  const { post_id, reaction_type } = payload;
  const user_reacted =
    store.getState().newsfeed.processed_posts[post_id].user_reacted;
  const { name, primary_reaction } =
    store.getState().reactions.reactions[reaction_type];
  const newUserReacted: ReactionsProps.UserReacted = {
    ...user_reacted,
    reaction_name: name,
    reaction_primary_reaction: primary_reaction,
    reaction_type_id: reaction_type,
  };
  dispatch(
    actions.newsfeed.immediateUpdateForReactions_UPDATE({
      post_id,
      reaction_type,
      user_reacted: newUserReacted,
      previous_reaction_name: user_reacted.reaction_name,
    })
  );

  dispatch(actions.reactions.setUpdateAReactionToAPost_API_STATUS("progress"));
  API_INSTANCES.POST_REACTIONS.updateAReactionToAPost(payload)
    .then((response) => {
      const data =
        response.data as ReactionsProps.UpdateAReactionToAPostResponse;
      dispatch(
        actions.newsfeed.updateReactionCountForAPost({
          ...data,
          post_id: payload.post_id,
        })
      );
      dispatch(
        actions.reactions.setUpdateAReactionToAPost_API_STATUS("success")
      );
    })
    .catch((error) => {
      handleError(error, "updateAReactionToAPost");
      dispatch(actions.reactions.setUpdateAReactionToAPost_API_STATUS("error"));
    });
};
const removeAReactionFromAPost = (
  payload: ReactionsProps.RemoveAReactionFromAPostPayload
) => {
  const { post_id, reaction_type } = payload;
  const user_reacted =
    store.getState().newsfeed.processed_posts[post_id].user_reacted;
  const newUserReacted = {
    ...user_reacted,
    reacted: false,
    reaction_name: "",
    reaction_primary_reaction: "",
    reaction_id: "",
    reaction_type_id: 0,
  };
  dispatch(
    actions.newsfeed.immediateUpdateForReactions_REMOVE({
      post_id,
      reaction_type,
      user_reacted: newUserReacted,
      previous_reaction_name: user_reacted.reaction_name,
    })
  );

  dispatch(
    actions.reactions.setRemoveAReactionFromAPost_API_STATUS("progress")
  );
  API_INSTANCES.POST_REACTIONS.removeAReactionFromAPost(payload)
    .then((response) => {
      const data = response.data as ReactionsProps.AddReactionToAPostResponse;
      dispatch(
        actions.newsfeed.updateReactionCountForAPost({
          ...data,
          post_id: payload.post_id,
        })
      );
      dispatch(
        actions.reactions.setRemoveAReactionFromAPost_API_STATUS("success")
      );
    })
    .catch((error) => {
      handleError(error, "removeAReactionFromAPost");
      dispatch(
        actions.reactions.setRemoveAReactionFromAPost_API_STATUS("error")
      );
    });
};

const getSystemCuratedReactionTypes = () => {
  dispatch(
    actions.reactions.setGetSystemCuratedReactionTypes_API_STATUS("progress")
  );
  API_INSTANCES.POST_REACTIONS.getSystemCuratedReactionTypes()
    .then((response) => {
      const data =
        response.data as ReactionsProps.getSystemCuratedReactionTypesResponse;
      dispatch(actions.reactions.setSystemCuratedReactionTypes(data));
      dispatch(
        actions.reactions.setGetSystemCuratedReactionTypes_API_STATUS("success")
      );
    })
    .catch((error) => {
      handleError(error, "getSystemCuratedReactionTypes");
      dispatch(
        actions.reactions.setGetSystemCuratedReactionTypes_API_STATUS("error")
      );
    });
};

export const POST_REACTIONS = {
  addAReactionToAPost,
  getTotalReactionsForAPost,
  updateAReactionToAPost,
  removeAReactionFromAPost,
  getSystemCuratedReactionTypes,
};
